import { Button } from "@/components/sidebar/Button";

import type { ComponentProps } from "react";

type Props = ComponentProps<"div"> & {
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export function GraphZoomButtons({ onZoomIn, onZoomOut, ...props }: Props) {
  return (
    <div {...props}>
      <Button
        className="font-mono w-7 min-h-7 mb-[1px] bg-blue-100 dark:bg-blue-900 rounded-8 rounded-b-none"
        onClick={onZoomIn}
      >
        +
      </Button>
      <Button
        className="font-mono w-7 min-h-7 bg-blue-100 dark:bg-blue-900 rounded-8 rounded-t-none"
        onClick={onZoomOut}
      >
        -
      </Button>
    </div>
  );
}
